module.exports = __webpack_public_path__ + "img/purple-square-table-3.bd52c89e.png";